/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElCalendarRangeComponent } from './calendar-range.component';
import { ElCalendarRangeDayCellComponent, ElCalendarRangeYearCellComponent } from './calendar-range-cells';
import { ElBaseCalendarModule } from './base-calendar.module';


@NgModule({
  imports: [ElBaseCalendarModule],
  exports: [ElCalendarRangeComponent],
  declarations: [
    ElCalendarRangeComponent,
    ElCalendarRangeDayCellComponent,
    ElCalendarRangeYearCellComponent,
  ],
  entryComponents: [ElCalendarRangeDayCellComponent, ElCalendarRangeYearCellComponent],
})
export class ElCalendarRangeModule {
}
